import { faker } from "@faker-js/faker";

// One-time deterministic seed so static catalogs (advertiser, users, creatives,
// etc.) are identical across reloads. Time-series generators below still anchor
// on `new Date()` so the dataset stays fresh day-to-day without re-seeding.
faker.seed(42);

export { faker };
